export const API_KEY = `41e59bf56bb30803a5891775`;
export const API_URL = `https://v6.exchangerate-api.com/v6/`;
export const TIMEOUT_SEC = 10;
export const SUPPORTED_COUNTRY_CODES = [
	{ code: "AED", fullName: "UAE Dirham", country: "United Arab Emirates" },
	{ code: "AFN", fullName: "Afghan Afghani", country: "Afghanistan" },
	{ code: "ALL", fullName: "Albanian Lek", country: "Albania" },
	{ code: "AMD", fullName: "Armenian Dram", country: "Armenia" },
	{ code: "ANG", fullName: "Netherlands Antillian Guilder", country: "Netherlands Antilles" },
	{ code: "AOA", fullName: "Angolan Kwanza", country: "Angola" },
	{ code: "ARS", fullName: "Argentine Peso", country: "Argentina" },
	{ code: "AUD", fullName: "Australian Dollar", country: "Australia" },
	{ code: "AWG", fullName: "Aruban Florin", country: "Aruba" },
	{ code: "AZN", fullName: "Azerbaijani Manat", country: "Azerbaijan" },
	{ code: "BAM", fullName: "Bosnia and Herzegovina Mark", country: "Bosnia and Herzegovina" },
	{ code: "BBD", fullName: "Barbados Dollar", country: "Barbados" },
	{ code: "BDT", fullName: "Bangladeshi Taka", country: "Bangladesh" },
	{ code: "BGN", fullName: "Bulgarian Lev", country: "Bulgaria" },
	{ code: "BHD", fullName: "Bahraini Dinar", country: "Bahrain" },
	{ code: "BIF", fullName: "Burundian Franc", country: "Burundi" },
	{ code: "BMD", fullName: "Bermudian Dollar", country: "Bermuda" },
	{ code: "BND", fullName: "Brunei Dollar", country: "Brunei" },
	{ code: "BOB", fullName: "Bolivian Boliviano", country: "Bolivia" },
	{ code: "BRL", fullName: "Brazilian Real", country: "Brazil" },
	{ code: "BSD", fullName: "Bahamian Dollar", country: "Bahamas" },
	{ code: "BTN", fullName: "Bhutanese Ngultrum", country: "Bhutan" },
	{ code: "BWP", fullName: "Botswana Pula", country: "Botswana" },
	{ code: "BYN", fullName: "Belarusian Ruble", country: "Belarus" },
	{ code: "BZD", fullName: "Belize Dollar", country: "Belize" },
	{ code: "CAD", fullName: "Canadian Dollar", country: "Canada" },
	{ code: "CDF", fullName: "Congolese Franc", country: "Democratic Republic of the Congo" },
	{ code: "CHF", fullName: "Swiss Franc", country: "Switzerland" },
	{ code: "CLP", fullName: "Chilean Peso", country: "Chile" },
	{ code: "CNY", fullName: "Chinese Renminbi", country: "China" },
	{ code: "COP", fullName: "Colombian Peso", country: "Colombia" },
	{ code: "CRC", fullName: "Costa Rican Colon", country: "Costa Rica" },
	{ code: "CUC", fullName: "Cuban Convertible Peso", country: "Cuba" },
	{ code: "CUP", fullName: "Cuban Peso", country: "Cuba" },
	{ code: "CVE", fullName: "Cape Verdean Escudo", country: "Cape Verde" },
	{ code: "CZK", fullName: "Czech Koruna", country: "Czech Republic" },
	{ code: "DJF", fullName: "Djiboutian Franc", country: "Djibouti" },
	{ code: "DKK", fullName: "Danish Krone", country: "Denmark" },
	{ code: "DOP", fullName: "Dominican Peso", country: "Dominican Republic" },
	{ code: "DZD", fullName: "Algerian Dinar", country: "Algeria" },
	{ code: "EGP", fullName: "Egyptian Pound", country: "Egypt" },
	{ code: "ERN", fullName: "Eritrean Nakfa", country: "Eritrea" },
	{ code: "ETB", fullName: "Ethiopian Birr", country: "Ethiopia" },
	{ code: "EUR", fullName: "Euro", country: "European Union" },
	{ code: "FJD", fullName: "Fiji Dollar", country: "	Fiji" },
	{ code: "FKP", fullName: "Falkland Islands Pound", country: "Falkland Islands" },
	{ code: "FOK", fullName: "Faroese Króna", country: "Faroe Islands" },
	{ code: "GBP", fullName: "Pound Sterling", country: "United Kingdom" },
	{ code: "GEL", fullName: "Georgian Lari", country: "Georgia" },
	{ code: "GGP", fullName: "Guernsey Pound", country: "Guernsey" },
	{ code: "GHS", fullName: "Ghanaian Cedi", country: "Ghana" },
	{ code: "GIP", fullName: "Gibraltar Pound", country: "Gibraltar" },
	{ code: "GMD", fullName: "Gambian Dalasi", country: "The Gambia" },
	{ code: "GNF", fullName: "Guinean Franc", country: "Guinea" },
	{ code: "GTQ", fullName: "Guatemalan Quetzal", country: "Guatemala" },
	{ code: "GYD", fullName: "Guyanese Dollar", country: "Guyana" },
	{ code: "HKD", fullName: "Hong Kong Dollar", country: "Hong Kong" },
	{ code: "HNL", fullName: "Honduran Lempira", country: "Honduras" },
	{ code: "HRK", fullName: "Croatian Kuna", country: "Croatia" },
	{ code: "HTG", fullName: "Haitian Gourde", country: "Haiti" },
	{ code: "HUF", fullName: "Hungarian Forint", country: "Hungary" },
	{ code: "IDR", fullName: "Indonesian Rupiah", country: "Indonesia" },
	{ code: "ILS", fullName: "Israeli New Shekel", country: "Israel" },
	{ code: "IMP", fullName: "Manx Pound", country: "Isle of Man" },
	{ code: "INR", fullName: "Indian Rupee", country: "India" },
	{ code: "IQD", fullName: "Iraqi Dinar", country: "Iraq" },
	{ code: "IRR", fullName: "Iranian Rial", country: "Iran" },
	{ code: "ISK", fullName: "Icelandic Króna", country: "Iceland" },
	{ code: "JMD", fullName: "Jamaican Dollar", country: "Jamaica" },
	{ code: "JOD", fullName: "Jordanian Dinar", country: "Jordan" },
	{ code: "JPY", fullName: "Japanese Yen", country: "Japan" },
	{ code: "KES", fullName: "Kenyan Shilling", country: "Kenya" },
	{ code: "KGS", fullName: "Kyrgyzstani Som", country: "Kyrgyzstan" },
	{ code: "KHR", fullName: "Cambodian Riel", country: "Cambodia" },
	{ code: "KID", fullName: "Kiribati Dollar", country: "Kiribati" },
	{ code: "KMF", fullName: "Comorian Franc", country: "Comoros" },
	{ code: "KRW", fullName: "South Korean Won", country: "South Korea" },
	{ code: "KWD", fullName: "Kuwaiti Dinar", country: "Kuwait" },
	{ code: "KYD", fullName: "Cayman Islands Dollar", country: "Cayman Islands" },
	{ code: "KZT", fullName: "Kazakhstani Tenge", country: "	Kazakhstan" },
	{ code: "LAK", fullName: "Lao Kip", country: "Laos" },
	{ code: "LBP", fullName: "Lebanese Pound", country: "Lebanon" },
	{ code: "LKR", fullName: "Sri Lanka Rupee", country: "Sri Lanka" },
	{ code: "LRD", fullName: "Liberian Dollar", country: "Liberia" },
	{ code: "LSL", fullName: "Lesotho Loti", country: "Lesotho" },
	{ code: "LYD", fullName: "Libyan Dinar", country: "Libya" },
	{ code: "MAD", fullName: "Moroccan Dirham", country: "Morocco" },
	{ code: "MDL", fullName: "Moldovan Leu", country: "Moldova" },
	{ code: "MGA", fullName: "Malagasy Ariary", country: "Madagascar" },
	{ code: "MKD", fullName: "Macedonian Denar", country: "North Macedonia" },
	{ code: "MMK", fullName: "Burmese Kyat", country: "Myanmar" },
	{ code: "MNT", fullName: "Mongolian Tögrög", country: "Mongolia" },
	{ code: "MOP", fullName: "Macanese Pataca", country: "Macau" },
	{ code: "MRU", fullName: "Mauritanian Ouguiya", country: "Mauritania" },
	{ code: "MUR", fullName: "Mauritian Rupee", country: "Mauritius" },
	{ code: "MVR", fullName: "Maldivian Rufiyaa", country: "Maldives" },
	{ code: "MWK", fullName: "Malawian Kwacha", country: "Malawi" },
	{ code: "MXN", fullName: "Mexican Peso", country: "Mexico" },
	{ code: "MYR", fullName: "Malaysian Ringgit", country: "Malaysia" },
	{ code: "MZN", fullName: "Mozambican Metical", country: "Mozambique" },
	{ code: "NAD", fullName: "Namibian Dollar", country: "Namibia" },
	{ code: "NGN", fullName: "Nigerian Naira", country: "Nigeria" },
	{ code: "NIO", fullName: "Nicaraguan Córdoba", country: "Nicaragua" },
	{ code: "NOK", fullName: "Norwegian Krone", country: "Norway" },
	{ code: "NPR", fullName: "Nepalese Rupee", country: "Nepal" },
	{ code: "NZD", fullName: "New Zealand Dollar", country: "New Zealand" },
	{ code: "OMR", fullName: "Omani Rial", country: "Oman" },
	{ code: "PAB", fullName: "Panamanian Balboa", country: "Panama" },
	{ code: "PEN", fullName: "Peruvian Sol", country: "Peru" },
	{ code: "PGK", fullName: "Papua New Guinean Kina", country: "Papua New Guinea" },
	{ code: "PHP", fullName: "Philippine Peso", country: "Philippines" },
	{ code: "PKR", fullName: "Pakistani Rupee", country: "Pakistan" },
	{ code: "PLN", fullName: "Polish Złoty", country: "Poland" },
	{ code: "PYG", fullName: "Paraguayan Guaraní", country: "Paraguay" },
	{ code: "QAR", fullName: "Qatari Riyal", country: "Qatar" },
	{ code: "RON", fullName: "Romanian Leu", country: "Romania" },
	{ code: "RSD", fullName: "Serbian Dinar", country: "Serbia" },
	{ code: "RUB", fullName: "Russian Ruble", country: "Russia" },
	{ code: "RWF", fullName: "Rwandan Franc", country: "Rwanda" },
	{ code: "SAR", fullName: "Saudi Riyal", country: "Saudi Arabia" },
	{ code: "SBD", fullName: "Solomon Islands Dollar", country: "Solomon Islands" },
	{ code: "SCR", fullName: "Seychellois Rupee", country: "Seychelles" },
	{ code: "SDG", fullName: "Sudanese Pound", country: "Sudan" },
	{ code: "SEK", fullName: "Swedish Krona", country: "Sweden" },
	{ code: "SGD", fullName: "Singapore Dollar", country: "Singapore" },
	{ code: "SHP", fullName: "Saint Helena Pound", country: "Saint Helena" },
	{ code: "SLL", fullName: "Sierra Leonean Leone", country: "Sierra Leone" },
	{ code: "SOS", fullName: "Somali Shilling", country: "Somalia" },
	{ code: "SRD", fullName: "Surinamese Dollar", country: "Suriname" },
	{ code: "SSP", fullName: "South Sudanese Pound", country: "South Sudan" },
	{ code: "STN", fullName: "São Tomé and Príncipe Dobra", country: "São Tomé and Príncipe" },
	{ code: "SYP", fullName: "Syrian Pound", country: "Syria" },
	{ code: "SZL", fullName: "Eswatini Lilangeni", country: "Eswatini" },
	{ code: "THB", fullName: "Thai Baht", country: "Thailand" },
	{ code: "TJS", fullName: "Tajikistani Somoni", country: "Tajikistan" },
	{ code: "TMT", fullName: "Turkmenistan Manat", country: "Turkmenistan" },
	{ code: "TND", fullName: "Tunisian Dinar", country: "Tunisia" },
	{ code: "TOP", fullName: "Tongan Paʻanga", country: "Tonga" },
	{ code: "TRY", fullName: "Turkish Lira", country: "Turkey" },
	{ code: "TTD", fullName: "Trinidad and Tobago Dollar", country: "Trinidad and Tobago" },
	{ code: "TVD", fullName: "Tuvaluan Dollar", country: "Tuvalu" },
	{ code: "TWD", fullName: "New Taiwan Dollar", country: "Taiwan" },
	{ code: "TZS", fullName: "Tanzanian Shilling", country: "Tanzania" },
	{ code: "UAH", fullName: "Ukrainian Hryvnia", country: "Ukraine" },
	{ code: "UGX", fullName: "Ugandan Shilling", country: "Uganda" },
	{ code: "USD", fullName: "United States Dollar", country: "United States" },
	{ code: "UYU", fullName: "Uruguayan Peso", country: "Uruguay" },
	{ code: "UZS", fullName: "Uzbekistani So'm", country: "Uzbekistan" },
	{ code: "VES", fullName: "Venezuelan Bolívar Soberano", country: "Venezuela" },
	{ code: "VND", fullName: "Vietnamese Đồng", country: "Vietnam" },
	{ code: "VUV", fullName: "Vanuatu Vatu", country: "Vanuatu" },
	{ code: "WST", fullName: "Samoan Tālā", country: "Samoa" },
	{ code: "XAF", fullName: "Central African CFA Franc", country: "	CEMAC" },
	{ code: "XCD", fullName: "East Caribbean Dollar", country: "Organisation of Eastern Caribbean States" },
	{ code: "XDR", fullName: "Special Drawing Rights", country: "International Monetary Fund" },
	{ code: "XOF", fullName: "West African CFA franc", country: "CFA" },
	{ code: "XPF", fullName: "CFP Franc", country: "Collectivités d'Outre-Mer" },
	{ code: "YER", fullName: "Yemeni Rial", country: "Yemen" },
	{ code: "ZAR", fullName: "South African Rand", country: "South Africa" },
	{ code: "ZMW", fullName: "Zambian Kwacha", country: "Zambia" },
];
